module.exports = __webpack_public_path__ + "img/67_13.0b5bba48.png";